import { useEffect, useState } from "react";
import apiClient from "../api/api-client";

function useCalendarDateHelper({ user, month }) {
  const [disabledDates, setDisabledDates] = useState(undefined);

  useEffect(() => {
    setDisabledDates(undefined);

    if (!user) {
      return;
    }

    const calculateDisabledDates = async (signal) => {
      const monthAsDate = new Date(month);
      // const today = Date.now();
      const today = new Date();
      today.setUTCHours(0, 0, 0, 0);

      const entriesForThisMonth = await (
        await apiClient.getEntriesForMonth(monthAsDate, signal)
      ).json();

      const activeDates = new Set(
        entriesForThisMonth.map((timeStamp) =>
          new Date(timeStamp + "Z").getUTCDate()
        )
      );
      activeDates.add(today.getUTCDate()); // Add today's date to the active dates set

      const year = monthAsDate.getUTCFullYear();
      const monthInt = monthAsDate.getUTCMonth();

      // Disable dates without entries
      return Array.from(
        { length: new Date(Date.UTC(year, monthInt + 1, 0)).getDate() },
        (_, i) => new Date(Date.UTC(year, monthInt, i + 1))
      )
        .filter((date) => !activeDates.has(date.getUTCDate()))
        .map((date) => date.toISOString());
    };

    const controller = new AbortController();
    const signal = controller.signal;

    calculateDisabledDates(signal).then(setDisabledDates).catch(console.error);

    return () => {
      controller.abort();
      setDisabledDates(undefined);
    };
  }, [user, month]);

  return disabledDates;
}

export default useCalendarDateHelper;
